import React from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";

import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import AsyncGet from "../../../components/AsyncGet";
import PaymentForm from "../Register/Step/PaymentForm";

import style from "./style.module.css";

export default function ChangePaymentMethod(props) {
    const userProfile = useSelector((state) => state.storage.data);
    if(get(userProfile, "membership.membership_id", "") === "") return null;
    return (
        <Section className={style.signin}>
            <div className={style.signinWrapper}>
                <div className={style.formWrapper}>
                    <Title 
                        tag="h3" 
                        className="fontTeko" 
                        transform="uppercase"
                        align="center"
                    >
                        Change Payment Method
                    </Title>
                    <Spacer size="16" />
                    <Title tag="p" align="center">£1.00 will be charged and refunded</Title>
                    <AsyncGet
                        url="/payment/method-intent"
                        permissionText="Method Intent"
                        loadOnMount={true}
                        render={({ data }) => {
                            if(data) {
                                return (
                                    <PaymentForm
                                        personalDetails={userProfile}
                                        paymentIntentDetails={data}
                                        planId={get(userProfile, "membership.membership_id")}
                                        total={1.00}
                                        color="buttonPrimary"
                                        from="changepaymentmethod"
                                    />
                                )
                            }
                        }}
                    />
                </div>
            </div>
        </Section>
    )
}